<template>
  <div class="r-root-page">
    <div>
      <open-fund-header show-shopping-cart/>
      <router-view/>
    </div>
    <div class="r-footer">
      <go-to-signup/>
      <support />
      <terms-and-conditions-link-buttons/>
    </div>
  </div>
</template>

<script>
import OpenFundHeader from '@/components/meitav-dash/OpenFundHeader';
import Support from '@/components/Support';
import GoToSignup from '@/components/GoToSignup';
import TermsAndConditionsLinkButtons from '@/components/TermsAndConditionsLinkButtons';

export default {
  name: 'LoginRoot',
  components: { TermsAndConditionsLinkButtons, OpenFundHeader, Support, GoToSignup },
};
</script>
